import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  className = ''
}: RevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1],
    delay
  }} className={className} data-id="element-425">
      {children}
    </motion.div>;
}